
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Schedules/Schedules.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Schedules.html');
        
        var script = require('./Schedules.ts').default;
        module.exports = require('./Schedules.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    